const prepareStatusText = (customerPortalStatus, devicePortalStatus) => {
  return `Customer Portal: ${customerPortalStatus}; Device Portal: ${devicePortalStatus}`
}

export { prepareStatusText }
